import { reflectKeys } from "@helpers"
import { PRACTICE_PREFIX } from "./practice-prefix"
import {
    LESSON_SUCCESS,
    PRACTICE_ERROR,
    PRACTICE_REQUEST,
    QUIZZES_SUCCESS,
    SET_VIEWED_QUIZ
} from "./practice-mutations"
import PracticeRepository from "../repository/practice-repository"

export const { GET_QUIZZES, GET_LESSON } = reflectKeys(["GET_QUIZZES", "GET_LESSON"], PRACTICE_PREFIX)

export default {
    async [GET_QUIZZES](context, { lesson_id, quizId = null, isAuth = false }) {
        context.commit(PRACTICE_REQUEST)

        const result = await PracticeRepository.quizzes({ lesson_id }).catch(e => {
            context.commit(PRACTICE_ERROR, e)
        })

        const quizzes = result ? result.data : []

        if (quizId && isAuth) {
            let quiz = quizzes.find(q => q.id === quizId)

            if (!quiz) {
                quiz = quizzes[0]
            }

            const { data: questions } = await PracticeRepository.questions({
                lesson_id,
                quiz_id: quiz.id,
                attempt_id: quiz?.attempt?.id || null
            }).catch(e => {
                context.commit(PRACTICE_ERROR, e)
            })

            quiz.questions = questions

            context.commit(SET_VIEWED_QUIZ, quiz)
        }

        context.commit(QUIZZES_SUCCESS, quizzes)

        return result
    },

    async [GET_LESSON](context, { lesson_id }) {
        context.commit(PRACTICE_REQUEST)
        const result = await PracticeRepository.lesson({ lesson_id }).catch(e => {
            context.commit(PRACTICE_ERROR, e)
        })
        if (result) {
            context.commit(LESSON_SUCCESS, result.data)
        }
        return result
    }
}

/*
if (result && quizId && isAuth) {
    const quiz = quizzes.find(q => q.id === quizId)

    const questions = await PracticeRepository.questions({ lesson_id, quiz_id: quizId }).catch(e => {
        context.commit(PRACTICE_ERROR, e)
    })

    if (questions && questions.data) {
        quiz.questions = questions.data
    }

    context.commit(SET_VIEWED_QUIZ, quiz)
}*/
